/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SafeAndEcoDrivingIncentive {
    PAPER_HINT = 'PAPER_HINT',
    COURSE_OR_SIMULATOR = 'COURSE_OR_SIMULATOR',
    NONE = 'NONE',
}
